import { create } from 'zustand';

export interface SimilarDeal {
  user_defined: boolean,
  starred: boolean,
  starred_from_db: boolean,
  issue_id: number,
  security_code: string,
  offering_date: string,
  tax_code: string,
  state: string,
  state_enhancement: boolean,
  competitive: boolean,
  total_offering_amount: number,
  spline_lt_rating_composite: string,
  repayment_bucket: string,
  issuer_long_name: string,
  issue_description: string,
  dated_date: string,
  next_call_date: string,
  bond_insurance_code: string,
  maturity_date: number[],
  coupon: number[],
  offering_yield: number[],
  cusip: string[],
  sink_fund_type: string[],
  total_maturity_offering_amt: number[],
  spline_aaa: (number | undefined)[]
}

interface DealBuilderSimilarDealsStore {
  loading: boolean,
  setLoading: (loading: boolean) => void,

  similarDeals: SimilarDeal[],
  setSimilarDeals: (similarDeals: SimilarDeal[]) => void,

  selectedSimilarDealIds: number[],
  setSelectedSimilarDealIds: (similarDeals: number[]) => void,

  starredSimilarDealCusips: string[],
  setStarredSimilarDealCusips: (cusips: string[]) => void,
}

const useDealBuilderSimilarDealsStore = create<DealBuilderSimilarDealsStore>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading }),

  similarDeals: [],
  setSimilarDeals: (similarDeals: SimilarDeal[]) => set({ similarDeals, loading: false }),

  selectedSimilarDealIds: [],
  setSelectedSimilarDealIds: (selectedSimilarDealIds: number[]) => set({ selectedSimilarDealIds }),

  starredSimilarDealCusips: [],
  setStarredSimilarDealCusips: (starredSimilarDealCusips: string[]) => set({ starredSimilarDealCusips }),
}));

export default useDealBuilderSimilarDealsStore;
